import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { useAuth } from "../contexts/AuthContext";
import { useDatabase } from "../contexts/DatabaseContext";

import MachineCard from "./cards/MachineCard";
import Loading from "./Loading";

export default function Machines() {
	const { getUserFSM } = useDatabase();
	const { currentUser } = useAuth();

	const [finiteStateMachines, setFiniteStateMachines] = useState([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (currentUser) {
			getFiniteStateMachines();
		}
	}, [currentUser]);

	async function getFiniteStateMachines() {
		setLoading(true);
		const response = await getUserFSM();

		const machines = [];
		response.forEach((doc) => {
			machines.push({ ...doc.data(), id: doc.id });
		});
		setFiniteStateMachines([...machines]);
		setLoading(false);
	}

	return (
		<div className="machines">
			{loading ? <Loading description={"Cargando"} overlay /> : null}
			<Link to="/editor" className="create-machines-button">
				<div className="icon">add</div>
			</Link>
			{currentUser ? (
				<>
					{finiteStateMachines.length > 0 ? (
						<>
							{finiteStateMachines.map((machine) => {
								return (
									<MachineCard
										imageUrl={machine.previewImage}
										title={machine.name}
										id={machine.id}
										key={machine.id}
										timestamp={machine.createdAt}
									/>
								);
							})}
						</>
					) : (
						<p className="text-5">Aún no has creado ningún autómata.</p>
					)}
				</>
			) : (
				<p className="text-5">Debes iniciar sesión para ver tus autómatas.</p>
			)}
		</div>
	);
}
